/**
 * Dispatch a custom event to pause or resume editorial scroller
 *
 * @param {boolean} pause - true to pause the scroll and false to resume it
 */
const triggerEditorialScroll = pause => {
    const editorialScrollEvent = new CustomEvent('250.editorial.scroll', {
        bubbles: true,
        cancelable: true,
        detail: {pause}
    });
    window.dispatchEvent(editorialScrollEvent);
};

export default triggerEditorialScroll;
